import { Component, Input, OnInit, Output, ElementRef, Inject, ViewChild, NgZone } from "@angular/core";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyHttp } from "../../../../../tsScripts/providers/http/CompanyHttp";
import { SecurityModelDTO } from "../../../../../tsScripts/DTO/SecurityModelDTO";
import { ProfileDTO } from "./ProfileDTO";
import { MessageStorage } from "../../../../../tsScripts/util/MessageStorage";
import { ActivatedRoute } from "@angular/router";

@Component({
    templateUrl: "../../../../../views/components/support/companies/profile/modalEditProfile.html",
    providers: [CompanyHttp]
})
export class ModalEditProfile implements OnInit {

    @Input()
    selected: any;

    errorMessage: string;
    listProfile: any[];
    listModel: any[];

    modelSelected: SecurityModelDTO;
    profileSelected: ProfileDTO;
    profile: ProfileDTO;
    tmpProfile: ProfileDTO;
    countModel: number = 0;
    countProfile: number = 0;

    profileNameText;
    profileDescriptionText;

    private companyId: string;

    public profileEdit;

    closeModal() {
        this.activeModal.close();
        this.selected = null;
    }

    constructor(//private _ProfileDTO: ProfileDTO,
        private CompanyHttp: CompanyHttp,
        private routeLocation: ActivatedRoute,
        private activeModal: NgbActiveModal,
        private sanitizer: DomSanitizer,
        private zone: NgZone) {
        this.companyId = this.routeLocation.snapshot.queryParams.companyId;
        this.countModel = 0;
        this.countProfile = 0;
        this.errorMessage = "";
    }



    private getListModel() {
        this.errorMessage = "";
        this.CompanyHttp.listModelProfile(null).then((response) => {
            this.listModel = response.securityModels;
            this.listModel.unshift(new SecurityModelDTO("Seleccione un modelo"));
            for (let temp of this.listModel) {
                this.tmpProfile = temp;
                if (this.tmpProfile.modelId == this.selected.modelId) {
                    this.modelSelected = this.listModel[this.countModel];
                    this.getListProfiles(this.modelSelected.modelId, this.selected.profileId);
                    break;
                }
                this.countModel++;
            }

        }, (error) => {
            this.errorMessage = error.errorMessage;
        });
    }
    
    getListProfiles(valueModel, valueProfile) {
        this.zone.run(() => {
            this.ListProfiles(valueModel, valueProfile);
        });
    }


    private ListProfiles(valueModel, valueProfile) {
        this.errorMessage = "";
        this.CompanyHttp.listProfiles({ modelId: valueModel }).then((response) => {
            this.listProfile = response.profiles;
            this.listProfile.unshift({ description: "Seleccione una opción" });
            for (let temp of this.listProfile) {
                this.tmpProfile = temp;
                if (this.tmpProfile.profileId == this.selected.profileId) {
                    this.profileSelected = this.listProfile[this.countProfile];
                    break;
                }
                this.countProfile++;
            }
        }, (error) => {
            this.errorMessage = error.errorMessage;
        });
    }

    processProfileEdit(name, description) {
        this.profileEdit = {
            "companyId": this.companyId,
            "profileId": this.profileSelected.profileId,
            "modelId": this.modelSelected.modelId,
            "profileName": name,
            "profileDescription": description,
            //"isActive": ModalEditProfile.formatProcessActive(this.profile.isActive),
            "registerId": this.selected.registerId
        };

        this.CompanyHttp.processEditProfile(this.profileEdit).then(() => {
            MessageStorage.add("success", "El perfil ha sido editado correctamente");
            //this.loading=false;
            this.activeModal.dismiss();
        }, (error) => {
            this.errorMessage = error.errorMessage;
            //this.loading=false;
        });
    }


    public static formatProcessActive(active): string {
        let activeFormated: string = "";
        switch (active) {

            case 1:
                activeFormated = "1";
                break;
            case 0:
                activeFormated = "0";
                break;
            case true:
                activeFormated = "1";
                break;
            case false:
                activeFormated = "0";
                break;

        }
        return activeFormated;

    }

    getNameDescription() {
        this.profileNameText = this.profileSelected.profileName;
        this.profileDescriptionText = this.profileSelected.description;
    }




    ngOnInit() {
        this.profileNameText = this.selected.profileName;
        this.profileDescriptionText = this.selected.profileDescription;
        this.zone.run(() => {
            this.getListModel();
        });

    }
}